export default __webpack_public_path__ + "static/media/emanationoflife.9b83c57c.png";